import { ApiService } from './api.service';

export class WebsiteService extends ApiService {

  public async news(language: string = 'fr') {
    const result = await fetch(`${process.env.VUE_APP_WEBSITE_URL}/news?language=${language}`);
    const jsonResult = await result.json();
    return jsonResult;
  }

}

export default new WebsiteService();
